//@ts-nocheck
import * as io from 'socket.io-client';
import store from '../redux/store'
export default class Socket {
    _instance = null
    static getInstance(){
        if(this._instance){
            return this._instance
        } 
        else  {
            this._instance = this._createSocket();
            return this._instance;
        } 
    }
    

    static refreshSocket(){
        if(this._instance){
            this._instance.close();
        }
        this._instance =  this._createSocket()
        return this._instance;
    }
    
    
    static _createSocket(){
        const {  user } = store.getState()
        
        
        
        let instance = io.connect(`${process.env.REACT_APP_CHATCON_URL}`, { closeOnBeforeunload: false,path: '/socket',transports: ['websocket', 'longpolling'],query:{
            authorization:user.data.customerToken,
            // sessionId:user.data.sessionId,
            // dialogId:engagement.data.dialogId,
            // engagementId:engagement.data.engagementId,
        }})


        instance.on('connect_error', function() {
            console.log('Connection failed');
        });
        instance.on('reconnect_failed', function() {
            console.log('Reconnection failed');
        });
        return instance;
    }

    static close(){
        this._instance.close();
    }





}